import styled from 'styled-components';

export const FileNameArea = styled.div`
  font-size: 18px;
  word-break: break-all;
`;

export const UploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;
